import {
  types as coverageTypes
} from './coverage';
import {
  types as configTypes
} from './config';

const KEYS = {
  [ coverageTypes.COVERAGE_QUERY_REQUEST ]: 'coverage_query',
  [ coverageTypes.COVERAGE_QUERY_SUCCESS ]: 'coverage_query',
  [ coverageTypes.COVERAGE_QUERY_FAILURE ]: 'coverage_query',
  [ coverageTypes.COVERAGE_SHOW_REQUEST ]: 'coverage_show',
  [ coverageTypes.COVERAGE_SHOW_SUCCESS ]: 'coverage_show',
  [ coverageTypes.COVERAGE_SHOW_FAILURE ]: 'coverage_show',
  [ configTypes.CONFIG_REQUEST ]: 'config',
  [ configTypes.CONFIG_SUCCESS ]: 'config',
  [ configTypes.CONFIG_FAILURE ]: 'config',
};

const initialState = {};

export default (state = initialState, action) => {
  let key  = KEYS[action.type] || false;

  if (!key) {
    return state;
  }

  switch (action.type) {
    case coverageTypes.COVERAGE_QUERY_REQUEST:
      return {
        ...state,
        coverage_query: {
          state: 'request',
        },
        coverage_show: {
          state: false,
        }
      };
    case coverageTypes.COVERAGE_SHOW_REQUEST:
    case configTypes.CONFIG_REQUEST:
      return {
        ...state,
        [ key ]: {
          state: 'request'
        }
      };
    case coverageTypes.COVERAGE_QUERY_SUCCESS:
    case coverageTypes.COVERAGE_SHOW_SUCCESS:
    case configTypes.CONFIG_SUCCESS:
      return {
        ...state,
        [ key ]: {
          state: 'success'
        }
      };
    case coverageTypes.COVERAGE_QUERY_FAILURE:
    case coverageTypes.COVERAGE_SHOW_FAILURE:
    case configTypes.CONFIG_FAILURE:
      return {
        ...state,
        [ key ]: {
          state: 'fail',
          error: action.error,
        }
      };
    default:
      return state;
  }
}

const getMeta = (state, meta, key, _default = false) => {
  if (state[meta] && state[meta][key]) {
    return state[meta][key];
  }

  return _default;
};

export const getState = (state, meta) => getMeta(state, meta, 'state');
export const getError = (state, meta) => getMeta(state, meta, 'error');

export const isMetaFetching = (state, meta) => 'request' === getMeta(state, meta, 'state');
export const isMetaSuccess = (state, meta) => 'success' === getMeta(state, meta, 'state');
export const isMetaFailure = (state, meta) => 'fail' === getMeta(state, meta, 'state');
export const getMetaError = (state, meta) => getMeta(state, meta, 'error');



// WEBPACK FOOTER //
// ./src/reducers/meta.js